import { useNavigate } from "react-router-dom";
import { Composer } from "@/components/ui/Composer";

/**
 * The way in to GAIA: ask something, and land in the conversation.
 *
 * gaia-app's send button carried a microphone icon while being a plain submit - there is no voice
 * input. `Composer` draws an arrow, which is what the button does, and is the same control the
 * conversation itself uses.
 *
 * Its calendar shortcut is left out until /calendar exists.
 */
export function HomeScreen() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center gap-8 px-6 py-16 max-md:px-4 max-md:py-10">
      <h1 className="text-center text-xl font-normal text-text-secondary">
        What would you like to do today?
      </h1>

      <Composer
        placeholder="Ask GAIA anything"
        autoFocus
        className="max-w-[560px]"
        onSend={(question) => {
          void navigate(`/chat?q=${encodeURIComponent(question)}`);
        }}
      />
    </div>
  );
}
